import { useEffect, useState } from 'react';
import { useQuery } from '@apollo/client';
import ReactHTMLParser from 'react-html-parser';

import { GET_PAGE_BY_SLUG } from '../../http/apollo-queries';

import { AccountNav } from '../Account/AccountNav';
import { Button, Card, Loading } from '../../components/UI';

const PrivacyAndTerms = () => {
  const [selectedPage, setSelectedPage] = useState('terms');
  const [pages, setPages] = useState({});

  const { data: termsData, loading: loadingTerms } = useQuery(
    GET_PAGE_BY_SLUG,
    {
      variables: {
        slug: 'terms',
      },
    }
  );

  const { data: privacyData, loading: loadingPrivacy } = useQuery(
    GET_PAGE_BY_SLUG,
    {
      skip: !termsData,
      variables: {
        slug: 'privacy-policy',
      },
    }
  );

  useEffect(() => {
    if (privacyData && termsData) {
      setPages({
        privacy: privacyData.getPageBySlug,
        terms: termsData.getPageBySlug,
      });
    }
  }, [termsData, privacyData]);

  return (
    <div className="flex flex-col w-full bg-white text-black items-center dark:bg-black-real dark:text-white">
      <div className="w-full lg:w-2/3X">
        <AccountNav />

        <Loading
          className={'mt-4 mx-auto'}
          status={loadingPrivacy || loadingTerms}
        />

        {Object.keys(pages).length === 2 && (
          <Card className="my-4" title={pages[selectedPage].title}>
            <div className="flex items-start mb-5">
              {Object.keys(pages).map((p, index) => (
                <Button
                  buttonClass="w-44 mr-5 h-12 uppercase text-xs"
                  variant="secondary"
                  key={pages[p].id}
                  onClick={() => setSelectedPage(p)}
                  isFocused={p === selectedPage}
                >
                  {pages[p].title}
                </Button>
              ))}
            </div>
            <div className="pt-3 text-sm">
              {ReactHTMLParser(pages[selectedPage].content)}
            </div>
          </Card>
        )}
      </div>
    </div>
  );
};

export default PrivacyAndTerms;
